<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新建项目"
      width="1200px"
      @close="closeDialog"
    >
      <el-form :model="project" :ref="`form`" label-width="140px">
        <el-form-item label="币种：" prop="coinType" required>
          <el-select v-model="project.coinType" placeholder="请选择币种">
            <el-option
              v-for="item in coinList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目类型：" prop="type" required>
          <el-select v-model="project.type" placeholder="请选择项目类型">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目：" prop="title" required>
          <el-input
            v-for="lang in languageList"
            :key="lang.value"
            :placeholder="`${lang.label}题目`"
            v-model="project.title[lang.value]"
            class="input"
          ></el-input>
        </el-form-item>
        <el-form-item label="题目需要详细介绍：">
          <el-checkbox v-model="needDescription"></el-checkbox>
        </el-form-item>
        <el-form-item
          v-if="needDescription"
          :label="`题目介绍（${lang.label}）：`"
          v-for="lang in languageList"
          :key="lang.value"
        >
          <editor
            v-model="project.description[lang.value]"
            class="editor"
          ></editor>
        </el-form-item>
        <el-form-item label="选项：" prop="options" required>
          <div v-for="(option, index) in project.options" :key="index">
            <div>
              选项 {{ index + 1 }}
              <el-button
                type="danger"
                class="remove-button"
                icon="el-icon-delete"
                circle
                size="small"
                @click="project.options.splice(index, 1)"
              ></el-button>
            </div>
            <el-input
              v-for="lang in languageList"
              :key="lang.value"
              :placeholder="`${lang.label}选项`"
              v-model="option.value[lang.value]"
              class="input"
            ></el-input>
          </div>
          <el-button
            type="success"
            @click="project.options.push({ value: {} })"
            class="create-button"
            >添加选项</el-button
          >
        </el-form-item>
        <el-form-item label="起止时间：" required>
          <el-col :span="7">
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="project.startTime"
                value-format="timestamp"
                type="datetime"
                placeholder="选择开始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item prop="endTime">
              <el-date-picker
                v-model="project.endTime"
                value-format="timestamp"
                type="datetime"
                placeholder="选择截止时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import LANGUAGE from 'common/languages';
import AnswerInput from '../answerInput';
import Editor from 'components/editor';

export default {
  name: 'quizCreate',
  data() {
    const validateEndTime = (rule, value, callback) => {
      if (!this.project.endTime) {
        callback(new Error('请填写'));
      }
      if (
        this.project.startTime &&
        this.project.endTime &&
        value < this.project.startTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };
    const validateStartTime = (rule, value, callback) => {
      if (!this.project.startTime) {
        callback(new Error('请填写'));
      }
      if (this.project.startTime < new Date())
        callback(new Error('开始时间不得早于当前时间'));
      callback();
    };
    const validateLanguage = (rule, value, callback) => {
      if (!(this.project.title && this.project.title[1])) {
        callback(new Error('至少填写中文'));
      }
      callback();
    };
    const validateAnswer = (rule, value, callback) => {
      if (!(this.project.options && this.project.options.length >= 2)) {
        callback(new Error('至少需要两个选项'));
      } else {
        this.project.options.forEach(item => {
          const hasEmpty = this.languageList.find(
            lang => !(item[lang.value] && item[lang.value].trim() !== '')
          );
          if (hasEmpty) {
            callback(new Error('选项中的所有语言，未翻译可都填写为中文'));
          }
        });
      }
      callback();
    };

    return {
      dialogVisible: false,
      needDescription: false,
      project: {
        title: {},
        options: [{ value: {} }, { value: {} }],
        description: {}
      },
      currentLang: '1',
      rules: {
        title: {
          validator: validateLanguage
        },
        options: {
          validator: validateAnswer
        },
        startTime: [
          {
            validator: validateStartTime,
            trigger: 'change'
          }
        ],
        endTime: [
          {
            validator: validateEndTime,
            trigger: 'change'
          }
        ]
      }
    };
  },
  components: {
    AnswerInput,
    Editor
  },
  computed: {
    ...mapState('quiz', ['languageList', 'typeList']),
    ...mapGetters('quiz', ['coinList'])
  },
  methods: {
    ...mapActions('quiz', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.project = {
        title: {},
        options: [{ value: {} }, { value: {} }],
        description: {}
      };
      this.needDescription = false;
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        valid && this.doSave();
      });
    },
    doSave() {
      this.create({
        ...this.project,
        options: this.project.options.map((item, index) => {
          return {
            ...item,
            id: index + 1
          };
        })
      }).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.editor {
  height: 100px;
}

.input + .input {
  margin-top: 10px;
}

.create-button {
  margin-top: 10px;
}

.remove-button {
  margin: 10px 5px;
}
</style>
